<template>
  <div class="t-map">
    <!-- <div id="container" style="width:100vw;height:100vh;" /> -->
    <van-loading class="loading-center" loading-text="加载中..." size="50" />
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'TMap',
  data() {
    return {
      isiOS: false,
      longitude: '',
      latitude: ''
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const url = this.getConfigUrl()
      this.$Apis.getNtas({ url }).then(res => {
        if (res.code !== 200) return
        wx.config({
          debug: false, // 用来调试
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ['openLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.checkJsApi({
          jsApiList: ['openLocation'],
          success: function(res) {
            if (res.checkResult.openLocation === false) {
              alert('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！')
            }
          }
        })
        setTimeout(() => {
          wx.ready(function() {
            wx.openLocation({
              latitude: parseFloat(31.392872),
              longitude: parseFloat(120.66752),
              name: '苏州广济医院',
              address: '苏州市广前路11号、大庄里路14号',
              scale: 14,
              infoUrl: ''
            })
          })
        }, 300)
        wx.error(function(res) {})
      })
    },
    getConfigUrl() {
      const u = window.navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      // 安卓需要使用当前URL进行微信API注册（即当场调用location.href.split('#')[0]）
      // iOS需要使用进入页面的初始URL进行注册，（即在任何pushstate发生前，调用location.href.split('#')[0]）
      let url = ''
      if (isiOS) {
        url = (`${window.localStorage.getItem('_iosWXConfig_') || window.location.href.split('#')[0]}`)// 获取初始化的url相关参数
      } else {
        url = (window.location.href.split('#')[0])
      }
      return url
    }
    /* init() {
      let address = ''
      var center = new window.qq.maps.LatLng(31.392872, 120.66752)
      var map = new window.qq.maps.Map(document.getElementById('container'), {
        center: center,
        zoom: 15,
        disableDefaultUI: true
      })
      var infoWin = new window.qq.maps.InfoWindow({
        map: map
      })
      var geocoder = new window.qq.maps.Geocoder({
        complete: function(res) {
          address = res.detail.nearPois[0].name
        }
      })
      window.qq.maps.event.addListener(map, 'click', function(event) {
        this.longitude = event.latLng.getLat()
        this.latitude = event.latLng.getLng()
        const lat = new window.qq.maps.LatLng(this.longitude, this.latitude)
        geocoder.getAddress(lat)
        setTimeout(() => {
          infoWin.open()
          infoWin.setContent(
            '<div style="text-align:center;white-space:nowrap;">' +
              address +
              '</div>'
          )
          infoWin.setPosition(event.latLng)
        }, 200)
      })
    } */
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.t-map{
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
